import { useContext } from 'react';

import { CartContext } from '../../../contexts/CartContext';
import { AddToCartInput, LegacyCartItem } from '../types/cart-item.type';

interface LegacyCartContextValue {
  cartItems: LegacyCartItem[];
  itemCount: number;
  addProduct: (payload: unknown) => void;
  increase: (payload: LegacyCartItem) => void;
  decrease: (payload: LegacyCartItem) => void;
}

// Anti-corruption layer: the ONLY v2 file allowed to touch the legacy cart context.
export function useCart() {
  const { cartItems, itemCount, addProduct, increase, decrease } = useContext(
    CartContext
  ) as LegacyCartContextValue;

  const findLegacyItem = (id: string): LegacyCartItem | undefined =>
    cartItems.find((item: LegacyCartItem) => item._id === id);

  return {
    itemCount,
    getQuantity: (id: string) => findLegacyItem(id)?.quantity ?? 0,
    addItem: (input: AddToCartInput) =>
      addProduct({
        _id: input.id,
        name: input.name,
        price: input.price,
        photo: input.photo,
        type: input.type,
        weight: input.weight,
        persons: input.persons,
      }),
    increase: (id: string) => {
      const item = findLegacyItem(id);
      if (item) increase(item);
    },
    decrease: (id: string) => {
      const item = findLegacyItem(id);
      if (item) decrease(item);
    },
  };
}
